import { Injectable } from '@angular/core';
import { AccountDetailService } from '@rci/self-serve-fido/state/account/account-detail.service';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { BillingDetailEntity } from '@rogers/self-serve-common/billing-detail';

@Injectable({
  providedIn: 'root',
})
export class BillingDetailService {
  constructor(private readonly accountDetailService: AccountDetailService) {}

  getBillingDetail$(): Observable<BillingDetailEntity> {
    return this.accountDetailService
      .getSelectedAccountDetail$()
      .pipe(switchMap(accountDetail => this.accountDetailService.getBillingDetail$(accountDetail.accountNumber)));
  }
}
